function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.205 2.25h3.308l-7.227 8.26 8.502 11.24H16.13l-5.214-6.817L4.95 21.75H1.64l7.73-8.835L1.215 2.25H8.04l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.045 4.126H5.078L17.044 19.77z"
});

var SvgTwitterX = function SvgTwitterX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE4LjIwNSAyLjI1aDMuMzA4bC03LjIyNyA4LjI2bDguNTAyIDExLjI0SDE2LjEzbC01LjIxNC02LjgxN0w0Ljk1IDIxLjc1SDEuNjRsNy43My04LjgzNUwxLjIxNSAyLjI1SDguMDRsNC43MTMgNi4yMzFsNS40NS02LjIzMVptLTEuMTYxIDE3LjUyaDEuODMzTDcuMDQ1IDQuMTI2SDUuMDc4TDE3LjA0NCAxOS43N1oiPjwvcGF0aD48L3N2Zz4=";
export { SvgTwitterX as ReactComponent };